import React from "react";
import "./style.css";
import {QuestionnaireMultiple} from "../../../../components/QuestionnaireMultiple";

export const Habits = (props) => {
  const list = {
    title: "Do you have any of these habits?",
    subtitle: "Choose all that apply",
    list: [
      { value: "Emotional or boredom eating" },
      { value: "Overeating" },
      { value: "Late-night snacking" },
      { value: "Skipping meals too often" },
      { value: "None of the above", isNone: true }
    ]
  };

  return (
    <div className="gallery-page">
      <QuestionnaireMultiple {...props} list={list} />
    </div>
  );
};
